/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EnrollmentActivityLogGroupType {
  ELECTION = 'ELECTION',
  PAYMENTS = 'PAYMENTS',
  CARRIER_APPLICATION = 'CARRIER_APPLICATION',
  SINGLE = 'SINGLE',
}
